// extracted by mini-css-extract-plugin
export default {"footer":"UserHistoryDrawerAllComments-footer-f7617aa8e2707678790e9bf4b1996232","loadMore":"UserHistoryDrawerAllComments-loadMore-87ebee5760cc43f32166b53ea2b34665"};